import _classCallCheck from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/regenerator/index.js";
import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-bc94f8e1.js';
function i(o, e) {
  var t = o.querySelectorAll(e),
    n = o.shadowRoot ? o.shadowRoot.querySelectorAll(e) : [];
  return Array.from(t).concat(Array.from(n));
}
function a(o, e) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              n = [], r = i(o, e);
              _context.t0 = r && r.length > 0;
              if (!_context.t0) {
                _context.next = 7;
                break;
              }
              r.forEach(function (m) {
                n.push(m.lazyLoadContent());
              });
              _context.next = 6;
              return Promise.all(n);
            case 6:
              t();
            case 7:
              t();
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function l(o) {
  return new Promise(function (e) {
    if (!o) {
      e();
      return;
    }
    o.forEach(function (t) {
      t.hasAttribute("data-src") && (t.setAttribute("src", "".concat(t.getAttribute("data-src"))), t.removeAttribute("data-src"), t.classList.contains("deckgo-reveal") || t.style.setProperty("visibility", "inherit")), t.style.setProperty("pointer-events", "none");
    }), e();
  });
}
function d(o) {
  return new Promise(function (e) {
    if (!o) {
      e();
      return;
    }
    o.forEach( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return t.lazyLoad();
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()), e();
  });
}
function c(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              t = [];
              t.push(u(o));
              t.push(f(o));
              _context3.next = 5;
              return Promise.all(t);
            case 5:
              e();
            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }());
}
function u(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              t = i(o, "img");
              _context4.next = 3;
              return l(t);
            case 3:
              e();
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }());
}
function f(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              t = i(o, "deckgo-lazy-img");
              _context5.next = 3;
              return d(t);
            case 3:
              e();
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }());
}
function P(o) {
  return new Promise(function (e) {
    var t = i(o, "img");
    t && (t = t.filter(function (n) {
      return n.getAttribute("data-src");
    }), t.forEach(function (n) {
      n.style.setProperty("visibility", "hidden");
    })), e();
  });
}
var s = "deckgo-reveal, deckgo-reveal-list, deckgo-highlight-code[highlight-lines]";
function p(_x6) {
  return _p.apply(this, arguments);
}
function _p() {
  _p = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(o) {
    var e, t;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            e = o.querySelectorAll(s);
            if (!(!e || e.length <= 0)) {
              _context9.next = 3;
              break;
            }
            return _context9.abrupt("return", !0);
          case 3:
            t = Array.from(e).find(function (n) {
              return n.revealProgress !== "end" && n.revealProgress !== void 0;
            });
            if (!t) {
              _context9.next = 10;
              break;
            }
            _context9.next = 7;
            return t.reveal();
          case 7:
            _context9.t0 = !1;
            _context9.next = 11;
            break;
          case 10:
            _context9.t0 = !0;
          case 11:
            return _context9.abrupt("return", _context9.t0);
          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _p.apply(this, arguments);
}
function g(_x7) {
  return _g.apply(this, arguments);
}
function _g() {
  _g = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(o) {
    var e, t, n;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            e = o.querySelectorAll(s);
            if (!(!e || e.length <= 0)) {
              _context10.next = 3;
              break;
            }
            return _context10.abrupt("return", !0);
          case 3:
            t = !0, n = Array.from(e).reverse().find(function (r) {
              return r.revealProgress !== "start" && r.revealProgress !== void 0;
            });
            _context10.t0 = n;
            if (!_context10.t0) {
              _context10.next = 9;
              break;
            }
            _context10.next = 8;
            return n.hide();
          case 8:
            t = !1;
          case 9:
            return _context10.abrupt("return", t);
          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _g.apply(this, arguments);
}
function M(_x8) {
  return _M.apply(this, arguments);
}
function _M() {
  _M = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(o) {
    var e, t;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            e = o.querySelectorAll(s);
            if (!(!e || e.length <= 0)) {
              _context11.next = 3;
              break;
            }
            return _context11.abrupt("return");
          case 3:
            t = Array.from(e).map(function (n) {
              return n.revealAll();
            });
            _context11.next = 6;
            return Promise.all(t);
          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _M.apply(this, arguments);
}
function x(_x9) {
  return _x10.apply(this, arguments);
}
function _x10() {
  _x10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(o) {
    var e, t;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            e = o.querySelectorAll(s);
            if (!(!e || e.length <= 0)) {
              _context12.next = 3;
              break;
            }
            return _context12.abrupt("return");
          case 3:
            t = Array.from(e).map(function (n) {
              return n.hideAll();
            });
            _context12.next = 6;
            return Promise.all(t);
          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _x10.apply(this, arguments);
}
function H(_x11, _x12, _x13) {
  return _H.apply(this, arguments);
}
function _H() {
  _H = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(o, e, t) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!t) {
              _context13.next = 13;
              break;
            }
            if (!e) {
              _context13.next = 7;
              break;
            }
            _context13.next = 4;
            return p(o);
          case 4:
            _context13.t1 = _context13.sent;
            _context13.next = 10;
            break;
          case 7:
            _context13.next = 9;
            return g(o);
          case 9:
            _context13.t1 = _context13.sent;
          case 10:
            _context13.t0 = _context13.t1;
            _context13.next = 14;
            break;
          case 13:
            _context13.t0 = !0;
          case 14:
            return _context13.abrupt("return", _context13.t0);
          case 15:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _H.apply(this, arguments);
}
function A() {
  return Promise.resolve();
}
function C(_x14) {
  return _C.apply(this, arguments);
}
function _C() {
  _C = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(o) {
    var e;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            e = [];
            e.push(c(o));
            e.push(a(o, "deckgo-gif"));
            e.push(a(o, "deckgo-youtube"));
            e.push(a(o, "deckgo-demo"));
            e.push(a(o, "deckgo-word-cloud"));
            e.push(a(o, "deckgo-markdown"));
            _context14.next = 9;
            return Promise.all(e);
          case 9:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _C.apply(this, arguments);
}
var deckdeckgoSlideSplitCss = ":host{display:block;position:relative;-webkit-user-select:var(--slide-user-select, none);-moz-user-select:var(--slide-user-select, none);-ms-user-select:var(--slide-user-select, none);user-select:var(--slide-user-select, none);background:var(--background);color:var(--color);height:inherit;z-index:var(--zIndex, 1);--slide-padding-top-default:64px;--slide-padding-end-default:64px;--slide-padding-bottom-default:64px;--slide-padding-start-default:64px}@media screen and (max-width: 1024px){:host{--slide-padding-top-default:32px;--slide-padding-end-default:32px;--slide-padding-bottom-default:32px;--slide-padding-start-default:32px}}div.deckgo-slide,div.deckgo-slide-vertical{display:flex;overflow:var(--overflow, hidden);padding:var(--slide-padding-top, var(--slide-padding-top-default)) var(--slide-padding-end, var(--slide-padding-end-default)) var(--slide-padding-bottom, var(--slide-padding-bottom-default)) var(--slide-padding-start, var(--slide-padding-start-default));width:calc( var(--slide-width) - var(--slide-padding-start, var(--slide-padding-start-default)) - var(--slide-padding-end, var(--slide-padding-end-default)) );height:calc( var(--slide-height) - var(--slide-padding-top, var(--slide-padding-top-default)) - var(--slide-padding-bottom, var(--slide-padding-bottom-default)) );min-height:calc( var(--slide-min-height) - var(--slide-padding-top, var(--slide-padding-top-default)) - var(--slide-padding-bottom, var(--slide-padding-bottom-default)) );user-drag:none;-webkit-user-drag:none}@media print{div.deckgo-slide,div.deckgo-slide-vertical{padding:0;page-break-after:always;height:100vh}::slotted([slot=actions]){display:none}::slotted([slot=background]){display:var(--slide-background-print-display, none)}}::slotted(ul),::slotted(ol){-webkit-padding-start:var(--slide-padding-start, var(--slide-padding-start-default));padding-inline-start:var(--slide-padding-start, var(--slide-padding-start-default))}::slotted([slot=notes]){display:none}::slotted([slot=actions]){position:absolute;top:var(--slide-actions-top, 16px);right:var(--slide-actions-end, 32px);left:var(--slide-actions-start);display:var(--slide-actions-display);z-index:var(--slide-actions-z-index)}::slotted([slot=background]){position:var(--slide-background-position, absolute);top:var(--slide-background-top, 0);right:var(--slide-background-end);left:var(--slide-background-start, 0);width:var(--slide-background-width);height:var(--slide-background-height);z-index:-2;pointer-events:none}::slotted([slot=header]),::slotted([slot=footer]){position:absolute;left:0;width:var(--slide-width);height:100%;display:flex;align-items:center;z-index:var(--slide-header-footer-z-index, -1)}::slotted([slot=header]){top:0;width:calc(var(--slide-width) - var(--slide-header-margin-start, 32px) - var(--slide-header-margin-end, 32px));max-height:var(--slide-header-max-height, 48px);justify-content:var(--slide-header-justify-content, flex-start);margin:var(--slide-header-margin-top, 16px) var(--slide-header-margin-end, 32px) var(--slide-header-margin-bottom, 16px) var(--slide-header-margin-start, 32px)}@media screen and (max-width: 1024px){::slotted([slot=header]){max-height:var(--slide-header-max-height, 16px)}}::slotted([slot=footer]){bottom:0;width:calc(var(--slide-width) - var(--slide-footer-margin-start, 16px) - var(--slide-footer-margin-end, 16px));max-height:var(--slide-footer-max-height, 32px);justify-content:var(--slide-footer-justify-content, center);margin:var(--slide-footer-margin-top, 16px) var(--slide-footer-margin-end, 16px) var(--slide-footer-margin-bottom, 16px) var(--slide-footer-margin-start, 16px)}:host{--slide-actions-z-index:3;--slide-header-footer-z-index:1}div.deckgo-slide,div.deckgo-slide-vertical{flex-flow:row wrap;padding:0;width:var(--slide-width);height:var(--slide-height);min-height:var(--slide-min-height)}div.deckgo-slide-vertical{flex-flow:column wrap}div.deckgo-slide-split,div.deckgo-slide-split-vertical{flex:1;height:calc( var(--slide-height) - (var(--slide-split-padding-bottom, var(--slide-padding-bottom-default))) - (var(--slide-split-padding-top, var(--slide-padding-top-default))) );width:calc( ( var(--slide-width) - (2 * var(--slide-split-padding-end, var(--slide-padding-end-default))) - (2 * var(--slide-split-padding-start, var(--slide-padding-start-default))) ) / 2 );align-items:var(--slide-split-align, inherit);text-align:var(--slide-split-text-align, inherit);padding:var(--slide-split-padding-top, var(--slide-padding-top-default)) var(--slide-split-padding-end, var(--slide-padding-end-default)) var(--slide-split-padding-bottom, var(--slide-padding-bottom-default)) var(--slide-split-padding-start, var(--slide-padding-start-default))}div.deckgo-slide-split.deckgo-slide-split-start,div.deckgo-slide-split-start.deckgo-slide-split-vertical{display:var(--slide-split-display-start, flex);background:var(--slide-split-background-start);color:var(--slide-split-color-start)}div.deckgo-slide-split.deckgo-slide-split-end,div.deckgo-slide-split-end.deckgo-slide-split-vertical{display:var(--slide-split-display-end, flex);background:var(--slide-split-background-end);color:var(--slide-split-color-end)}div.deckgo-slide-split-vertical{min-height:calc( (var(--slide-min-height, var(--slide-height)) / 2) - (var(--slide-split-padding-bottom, var(--slide-padding-bottom-default))) - (var(--slide-split-padding-top, var(--slide-padding-top-default))) );height:auto;width:calc( var(--slide-width) - (var(--slide-split-padding-end, var(--slide-padding-end-default))) - (var(--slide-split-padding-start, var(--slide-padding-start-default))) )}::slotted([slot=title]){flex:1 100%;display:var(--slide-split-title-display, none);max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content;padding:var(--slide-split-title-padding-top, var(--slide-padding-top-default)) var(--slide-split-title-padding-end, var(--slide-padding-end-default)) var(--slide-split-title-padding-bottom, var(--slide-padding-bottom-default)) var(--slide-split-title-padding-start, var(--slide-padding-start-default))}::slotted([slot=title]),::slotted([slot=start]),::slotted([slot=end]){z-index:2;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}";
var DeckdeckgoSlideSplit = /*#__PURE__*/function () {
  function DeckdeckgoSlideSplit(hostRef) {
    _classCallCheck(this, DeckdeckgoSlideSplit);
    registerInstance(this, hostRef);
    this.slideDidLoad = createEvent(this, "slideDidLoad", 7);
    /**
     * If you define a background for the all deck but, a specific one for this slide, set this option to true
     */
    this.customBackground = false;
    /**
     * If you provide actions for the all deck but, a specific one for this slide, set this option to true
     */
    this.customActions = false;
    /**
     * Split the slide horizontally (false) or vertically (true)
     */
    this.vertical = false;
    /**
     * Set to "demo" if you use such component in one of the start or end section
     */
    this.type = 'default';
  }
  _createClass(DeckdeckgoSlideSplit, [{
    key: "componentDidLoad",
    value: function () {
      var _componentDidLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return P(this.el);
              case 2:
                this.slideDidLoad.emit();
              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function componentDidLoad() {
        return _componentDidLoad.apply(this, arguments);
      }
      return componentDidLoad;
    }()
  }, {
    key: "beforeSwipe",
    value: function beforeSwipe(enter, reveal) {
      return H(this.el, enter, reveal);
    }
  }, {
    key: "afterSwipe",
    value: function afterSwipe() {
      return A();
    }
  }, {
    key: "lazyLoadContent",
    value: function lazyLoadContent() {
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve) {
          var promises;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  promises = [];
                  promises.push(C(_this.el));
                  promises.push(_this.resizeDemo());
                  _context7.next = 5;
                  return Promise.all(promises);
                case 5:
                  resolve();
                case 6:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
        return function (_x15) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "revealContent",
    value: function revealContent() {
      return M(this.el);
    }
  }, {
    key: "hideContent",
    value: function hideContent() {
      return x(this.el);
    }
  }, {
    key: "resizeDemo",
    value: function () {
      var _resizeDemo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var element;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.type !== 'demo')) {
                  _context8.next = 2;
                  break;
                }
                return _context8.abrupt("return");
              case 2:
                element = this.el.querySelector(':scope > deckgo-demo');
                if (!(element && typeof element.updateIFrame === 'function')) {
                  _context8.next = 6;
                  break;
                }
                _context8.next = 6;
                return element.updateIFrame();
              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function resizeDemo() {
        return _resizeDemo.apply(this, arguments);
      }
      return resizeDemo;
    }()
  }, {
    key: "render",
    value: function render() {
      var verticalAttr = this.vertical ? '-vertical' : '';
      return h(Host, {
        class: {
          'deckgo-slide-container': true
        }
      }, h("div", {
        class: "deckgo-slide".concat(verticalAttr)
      }, h("slot", {
        name: "title"
      }), h("div", {
        class: "deckgo-slide-split".concat(verticalAttr, " deckgo-slide-split-start")
      }, h("slot", {
        name: "start"
      })), h("div", {
        class: "deckgo-slide-split".concat(verticalAttr, " deckgo-slide-split-end")
      }, h("slot", {
        name: "end"
      })), h("slot", {
        name: "notes"
      }), h("slot", {
        name: "actions"
      }), h("slot", {
        name: "background"
      }), h("slot", {
        name: "header"
      }), h("slot", {
        name: "footer"
      })));
    }
  }, {
    key: "el",
    get: function get() {
      return getElement(this);
    }
  }]);
  return DeckdeckgoSlideSplit;
}();
DeckdeckgoSlideSplit.style = deckdeckgoSlideSplitCss;
export { DeckdeckgoSlideSplit as deckgo_slide_split };